import { Box } from "@mui/material";

interface ViewingWindowIndicatorProps {
  windowLeftPercent: number;
  windowWidthPercent: number;
}

export const ViewingWindowIndicator = ({
  windowLeftPercent,
  windowWidthPercent,
}: ViewingWindowIndicatorProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: `${windowLeftPercent}%`,
        width: `${windowWidthPercent}%`,
        top: 0,
        bottom: 0,
        border: 3,
        borderColor: "primary.main",
        bgcolor: "primary.main",
        opacity: 0.1,
        pointerEvents: "none",
        boxShadow: "inset 0 0 0 2px rgba(255, 255, 255, 0.5)",
      }}
    />
  );
};
